import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const MoreIcon = (props) => {
  const {...other} = props;
  return (
    <SvgIcon {...props} width="15" height="23" viewBox="0 0 60 60" {...other}>
      <path d="M30,16c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8S25.589,16,30,16z" fill="rgb(78 87 101)"/>
      <path d="M30,44c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,44,30,44z" fill="rgb(78 87 101)"/>
      <path d="M30,22c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S34.411,22,30,22z" fill="rgb(78 87 101)"/>
    </SvgIcon>
  );
};

MoreIcon.propTypes = {}

MoreIcon.defaultProps = {}

export default MoreIcon;